import { render, staticRenderFns } from "./BaseColourSelect.vue?vue&type=template&id=7507284e&scoped=true"
import script from "./BaseColourSelect.vue?vue&type=script&lang=js"
export * from "./BaseColourSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseColourSelect.vue?vue&type=style&index=0&id=7507284e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7507284e",
  null
  
)

export default component.exports